import { useEffect, useRef, useState } from "react";

import { useNetwork } from "../context/NetworkContext";
import { useShowAlert } from "../context/AlertContext";
import { usePermission } from "../context/PermissionContext";
import AxiosInstance from "../utils/AxiosInstance";
import handleError from "../constants/handleError";
import { CircularProgress } from "@mui/material";

export default function SaleSettings({
  isData,
  DateConverter,
  CurrencyConverter,
  handleSelectedSale,
  version,
  handlelatestSale,
  closeAuto,
  setCloseAuto,
  latestVersion
}) {
  const hasFetched = useRef(false);
  const [saleOpen, setSaleOpen] = useState(false);
  const [saleHistoryDate, setSaleHistoryDate] = useState([]);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const {
    permission,
    hasModulePermission,
    blockedPermissions,
  } = usePermission();
  const [saleHistoryLoading, setSaleHistoryLoading] = useState(false);
  const getBgColor = (status) => {
    if (!status || typeof status !== "string") return "bg-label-secondary";
    switch (status) {
      case "ADDED":
        return "bg-label-success";
      case "UPDATED":
        return "bg-label-bird";
      case "DELETED":
        return "bg-label-red";
      default:
        return "bg-label-secondary";
    }
  };

  const getSaleTrack = (status) => {
    switch (status) {
      case "ADDED":
        return "Original";
      case "UPDATED":
        return "Modified";
      case "DELETED":
        return "Cancelled";
      default:
        return status;
    }
  };
  const handleSaleHistory = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      setSaleHistoryLoading(true);
      const response = await AxiosInstance.get(`module/sale/history/${saleId}`);
      const history = response.data?.results || [];

      setSaleHistoryDate(history);
      handlelatestSale(history[history?.length-1])
    } catch (error) {
      handleError(error, showAlert);
      return null;
    } finally {
    setSaleHistoryLoading(false);
  }
  };

  const handleToggleSale = () => {
    const opening = !saleOpen;
    setSaleOpen(opening);
    setCloseAuto(true)
    if (opening && !hasFetched.current && isData?._id) {
      handleSaleHistory(isData?._id);
      hasFetched.current = true;
    }
  };

  useEffect(() => {
    if (!closeAuto) {
      setSaleOpen(false);
    }
  }, [closeAuto]);
  
// useEffect(()=>{
//     if (hasFetched.current) return;
//     hasFetched.current = true;
//    if((hasModulePermission("SALE") || permission === undefined) && 
//     (blockedPermissions("SALE:history") || permission === undefined))(
//     handleSaleHistory(isData?._id)
//     )
// },[])
  return (
    <>
    {
    (hasModulePermission("SALE") || permission === undefined) && 
    (blockedPermissions("SALE:history") || permission === undefined) && (
    <div
      className="mt-2"
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ padding: "8px 8px", cursor: "pointer", background: "#f9fafb" }}
        onClick={handleToggleSale}
      >
        <span className="font-13 fw-600">Sale History</span>
        <i
          className="bx bx-chevron-down font-18"
          style={{
            transition: "transform 0.2s",
            transform: saleOpen && closeAuto ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </div>
      {saleHistoryLoading ? (
        <div className="d-flex justify-content-center p-3">
          <CircularProgress size={20} className="text-primary" />
        </div>
      ) : (
      <>
      {saleOpen && closeAuto && (
        <ul className="p-2 m-0 list-unstyled" style={{ width: "100%" }}>
          {saleHistoryDate?.length > 0 ? (
            saleHistoryDate?.slice().reverse()?.map((sale, idx) => {
              const displayTime = DateConverter
                ? `${
                    DateConverter.ISOToDisplayFormat(
                      DateConverter.convertToTimeZone(
                        sale?.createdAt,
                        "Asia/Kolkata"
                      )
                    ).date
                  } ${
                    DateConverter.ISOToDisplayFormat(
                      DateConverter.convertToTimeZone(
                        sale?.createdAt,
                        "Asia/Kolkata"
                      )
                    ).time
                  }`
                : sale?.createdAt;
              const grandTotal = CurrencyConverter
                ? CurrencyConverter.toCurrency(
                    sale?.saleData?.grandtotal || 0,
                    "INR"
                  )
                : sale?.saleData?.grandtotal || 0;

              return (
                <li
                  key={sale?._id || idx}
                  className={`dropdown-item ${version=== sale?.saleVersion ? "active" : ""}`}
                  style={{ cursor: "pointer", padding: "0.483rem" }}
                  onClick={()=>handleSelectedSale(sale)}
                >
                  <div className="fw-semibold text-dark d-flex justify-content-between align-items-center">
                    <span>
                      <span style={{ fontWeight: "normal" }}>
                        v{sale?.saleVersion}
                      </span>
                      {" "}
                      {sale?.saleno}
                    </span>
                    <small
                      className={`badge rounded-pill ${getBgColor(
                        sale?.saleData?.saleTrack
                      )}`}
                    >
                      {getSaleTrack(sale?.saleData?.saleTrack)}
                    </small>
                    <small className="badge bg-label-fall rounded-pill">
                      ₹{grandTotal}
                    </small>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <small className="text-muted">
                      Items: {sale?.saleData?.totalItems || 0}
                    </small>
                    <small className="text-muted">{displayTime}</small>
                  </div>
                </li>
              );
            })
          ) : (
            <li className="dropdown-item text-muted">No Sale History</li>
          )}
        </ul>
      )}</>)}
    </div>
    )}
    </>
  );
}
